import { render, staticRenderFns } from "./articleDetail.vue?vue&type=template&id=9ed16a04&scoped=true&"
import script from "./articleDetail.vue?vue&type=script&lang=ts&"
export * from "./articleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./articleDetail.vue?vue&type=style&index=0&id=9ed16a04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed16a04",
  null
  
)

export default component.exports